import React,{useState,useEffect} from 'react'
import { Form, Input, Button } from 'antd'
import { MobileOutlined ,SafetyCertificateOutlined, MailOutlined  } from '@ant-design/icons'
// import CaptchaInput from './CaptchaInput'
import CaptchaImg from './CaptchaImg'
import { Link } from 'react-router-dom';
import CaptchaMsg from "./CaptchaMsg";
import {messageTips} from "../utils";
import {apiSendPhoneCode} from "../request/api";
import IDasImageCaptcha from "./IDasImageCaptcha";
import SecondValidate from "./SecondValidate";
import NormalLoginForm from "./NormalLoginForm";

const MobileLoginForm = (props) => {
    const { refreshFidData, handleClick, form,disabled,captchaShow,captcha,captchaImg,secondValidateShow,
        secondValidateId,setLoginButtonDisabled,setLoadingText,
        IDasImage,IDasImageCode,IDasImageClick,IDasImageShow,setIDasImageShow} = props
    const [sendBtnDisabled,setSendBtnDisabled] = useState(false);
    const [sendBtnText,setSendBtnText] = useState("发送验证码");
    const sendLoginValidateCode = () => {
        form.validateFields(["Phone"]).then(values=> {
            const params = {
                F_Phone: values.Phone,
                Identifying: "",
                F_PhoneCode: "",
                Type:"login"
            }
            apiSendPhoneCode(params).then(res => {
                console.log('登录验证码...........',res.data)
                if(res.data.IsSuccess){
                    form.setFieldsValue({SMSCodeId:res.data.data});
                    messageTips('验证码发送成功','success');
                    setSendBtnDisabled(true);
                    let time = 60;
                    let interval= setInterval(()=>{
                        time--;
                        setSendBtnText(time+"秒后重新获取");
                        if(time === 0) {
                            setSendBtnText("发送验证码");
                            setSendBtnDisabled(false);
                            clearInterval(interval)
                        }
                    },1000)
                } else {
                    messageTips(res.data.msg,'error')
                }
            }).catch(err => {
                messageTips(err,'error')
            })

        })

    }
    useEffect(()=> {
        // form.setFieldsValue({SMSCodeId:"ddddddddddd"})
    })
    return (
        <div>
            <Form
                form={form}
                name="normal_login"
                className="login-form"
                initialValues={{
                    remember: true,
                }}
            >
                <Form.Item name="SMSCodeId" hidden={true}>
                    <Input/>
                </Form.Item>
                <Form.Item label="手机号" name="Phone" rules={[
                    {
                        required: true,
                        message: '请输入手机号！',
                    },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: '手机号不合法！'
                    }
                ]}>
                    <Input prefix={<MobileOutlined   className="site-form-item-icon" />} placeholder="手机号" />
                </Form.Item>
                <div className="mobile-message-code">
                    <Form.Item label="验证码" name="SMSCode" rules={[{required: true, message: '请输入验证码！',}]}>
                        <Input maxLength={4}
                            prefix={<MailOutlined  className="site-form-item-icon" />}
                            placeholder="验证码"
                        />
                    </Form.Item>
                    <Button onClick={sendLoginValidateCode} disabled={sendBtnDisabled}>{sendBtnText}</Button>
                </div>
                {
                    captchaShow ? <CaptchaImg handleClick={handleClick} captcha={captcha} captchaImg={captchaImg}/> : <div></div>
                }
                {
                    IDasImageShow ?
                        <IDasImageCaptcha handleClick={IDasImageClick} captcha={IDasImageCode} captchaImg={IDasImage} />:""
                }
                {
                    secondValidateShow ? <SecondValidate validateId={secondValidateId} form={form} refreshData={refreshFidData} loading={setLoginButtonDisabled} loadingText={setLoadingText}
                                                         IDasImageShow={IDasImageShow} setIDasImageShow={setIDasImageShow} imgCode={IDasImageCode} refreshImageCode={IDasImageClick}
                                                         style={IDasImageShow ? {marginBottom: 10}:{marginBottom:0}}/>:""
                }
            </Form>
            {/*<div style={{position:'absolute',bottom:26}}>*/}
            {/*    <Button className="login_btn" disabled={disabled} onClick={onFinish}>*/}
            {/*        登录*/}
            {/*    </Button>*/}
            {/*</div>*/}
            {/*<div className="login-bottom">*/}
            {/*    <a>还没有账号？ 立即注册</a>*/}
            {/*</div>*/}
        </div>

    );
};

export default MobileLoginForm;
